import type { SVGProps } from 'react';

const ShareX = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' height={52} width={52} xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect fill='#000' height={52} rx={12} width={52} />
    <path
      d='M33.634 13.799h4.072L28.81 23.965l10.464 13.834h-8.193l-6.417-8.39-7.343 8.39h-4.074l9.514-10.874-10.038-13.126h8.4l5.802 7.669 6.708-7.67Zm-1.428 21.563h2.255L19.9 16.108h-2.42l14.727 19.254Z'
      fill='#fff'
    />
  </svg>
);
export default ShareX;
